
// from Google/firebase user
export interface IUser {
  uid: string
  displayName: string
  email: string
  photoURL: string | null
  isAdmin?: boolean
}

export class Language {
  constructor(public name: string, public code: string) {}
}

// export class Lesson {
//   constructor(public name: string, public created: string) {}
// }

export interface ITranslation {
  _id: string | null
  srcWord: string
  tgtWord: string
  order: number
}

export interface ILessonMetaData {
  _id: string
  creator: string // user id or email
  name: string
  created: string
  srcLang: string
  tgtLang: string
}

export interface ILesson extends ILessonMetaData {
  words: ITranslation[]
}

export const languages = [
  new Language('English', 'gb'),
  new Language('Français', 'fr')
]

export interface IWord {
  word: string
  lang: string
}

export interface IAnswer {
  value: string | null
  correct: boolean
}

export interface ITestConfig {
  // number of questions (max = nb words in lesson)
  nbWords: number
  // ... or predefined words (ex when replaying a test)
  words?: IWord[]
  // test language either srcLang or tgtLang or '' for mixed
  lang: string
  flowMode: 'UserControlled' | 'Timed' | 'NoPause'
  pauseAfterAnswerSeconds: number
  // timeout, -1 = no automatic progression, 0 = wait for user action
  pauseAfterAnswer: number
}

export interface ITestResult {
  _id: string | null
  user: IUser
  lesson: ILessonMetaData
  config: ITestConfig
  
  startTime: string
  finishTime: string
  attempts: number

  questions: IWord[]
  answers: IAnswer[]

  state: 'finished' | 'cancelled'
  questionCount: number
  correctAnswers: number
  wrongAnswers: number
  score: number
  pass: boolean
}
